/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIFeedbackEnum } from './APIFeedbackEnum';
import {
    APIFeedbackEnumFromJSON,
    APIFeedbackEnumFromJSONTyped,
    APIFeedbackEnumToJSON,
} from './APIFeedbackEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIProductionFeedback
 */
export interface APIProductionFeedback {
    /**
     * 
     * @type {string}
     * @memberof APIProductionFeedback
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIProductionFeedback
     */
    readonly productionOrder: string;
    /**
     * 
     * @type {Date}
     * @memberof APIProductionFeedback
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIProductionFeedback
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {APIFeedbackEnum}
     * @memberof APIProductionFeedback
     */
    feedback: APIFeedbackEnum;
    /**
     * 
     * @type {Date}
     * @memberof APIProductionFeedback
     */
    time: Date;
    /**
     * 
     * @type {number}
     * @memberof APIProductionFeedback
     */
    count: number;
}



/**
 * Check if a given object implements the APIProductionFeedback interface.
 */
export function instanceOfAPIProductionFeedback(value: object): value is APIProductionFeedback {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('productionOrder' in value) || value['productionOrder'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('feedback' in value) || value['feedback'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function APIProductionFeedbackFromJSON(json: any): APIProductionFeedback {
    return APIProductionFeedbackFromJSONTyped(json, false);
}

export function APIProductionFeedbackFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIProductionFeedback {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'productionOrder': json['production_order'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'feedback': APIFeedbackEnumFromJSON(json['feedback']),
        'time': (new Date(json['time'])),
        'count': json['count'],
    };
}

export function APIProductionFeedbackToJSON(value?: Omit<APIProductionFeedback, 'self'|'production_order'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'feedback': APIFeedbackEnumToJSON(value['feedback']),
        'time': ((value['time']).toISOString()),
        'count': value['count'],
    };
}

